// NIGHT-DIRECTSTAFF-2026-10-25b §1: bulk actions on leads, each a logged action. Assign has no column of its own (nothing to apply):
// every assignment is an activity_log row -- type 'lead_assign', "Assigned to <name> · by <staff email> · lead_id=<uuid>"
// ("Unassigned · …" to clear) -- and a lead's assignee is its newest such row. Each bulk run (mark test / spam, mark handled with
// a note, assign, and any Undo) also writes ONE 'bulk_action' row: "Bulk: <what> · <n> leads · by <email> · lead_ids=<id,id,…>",
// so the Activity page lists who did it.
export const ASSIGN_TYPE = 'lead_assign';
export const BULK_TYPE = 'bulk_action';
export const NAME_MAX = 40;
export const SUGGESTED = ['Matt', 'Brittany'];
const s = (v) => (v === null || v === undefined ? '' : String(v).trim());
export const cleanName = (v) => s(v).replace(/\s+/g, ' ').replace(/·/g, '-').slice(0, NAME_MAX);

export const assignNote = (leadId, to, by) => `${cleanName(to) ? `Assigned to ${cleanName(to)}` : 'Unassigned'}${by ? ` · by ${by}` : ''} · lead_id=${leadId}`;
const ASSIGN_RE = /^(?:Assigned to (.+?)|Unassigned)(?: · by (\S+))? · lead_id=([0-9a-f-]{36})$/i;
export function parseAssign(a) {
  if (!a || s(a.type) !== ASSIGN_TYPE) return null;
  const m = ASSIGN_RE.exec(s(a.note));
  return m ? { to: m[1] || '', by: m[2] || '', leadId: m[3].toLowerCase(), at: a.created_at || a.date || '' } : null;
}
/** activity rows -> Map(lead id -> { to, by, at }) : the newest assignment of each lead ('' to = unassigned, left out) */
export function assignees(activity = []) {
  const last = new Map();
  for (const a of [...(activity || [])].sort((x, y) => s(x.created_at).localeCompare(s(y.created_at)) || (Number(x.id) || 0) - (Number(y.id) || 0))) {
    const p = parseAssign(a); if (p) last.set(p.leadId, p);
  }
  for (const [k, v] of last) if (!v.to) last.delete(k);
  return last;
}
export const bulkNote = (what, ids, by) => `Bulk: ${what} · ${ids.length} lead${ids.length === 1 ? '' : 's'}${by ? ` · by ${by}` : ''} · lead_ids=${ids.join(',')}`;

export function makeAssignApi(supabase) {
  const by = async () => { try { const { data } = await supabase.auth.getUser(); return (data && data.user && data.user.email) || ''; } catch (e) { return ''; } };
  const today = () => new Date().toISOString().split('T')[0];
  return {
    /** ids -> name ('' = unassign) ; one row per lead -> { done, failed, rows } */
    async assign(ids, to) {
      const who = await by();
      const rows = ids.map((id) => ({ candidate_id: null, date: today(), type: ASSIGN_TYPE, note: assignNote(id, to, who) }));
      const { data, error } = await supabase.from('activity_log').insert(rows).select('id,type,note,date,created_at');
      if (error) return { done: [], failed: ids.map((id) => ({ id, error: error.message })), rows: [] };
      return { done: ids, failed: [], rows: data || rows };
    },
    /** one row for a whole bulk run (never fails the run: a log that could not be written is said, not thrown) */
    async logBulk(what, ids) {
      if (!ids || !ids.length) return true;
      const { error } = await supabase.from('activity_log').insert({ candidate_id: null, date: today(), type: BULK_TYPE, note: bulkNote(what, ids, await by()) });
      return !error;
    },
    async recent() {
      try {
        const { data, error } = await supabase.from('activity_log').select('id,type,note,date,created_at').eq('type', ASSIGN_TYPE).order('created_at', { ascending: true }).limit(5000);
        return error ? [] : (data || []);
      } catch (e) { return []; }
    },
  };
}
